"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hexToRgba = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var hexToRgba = function hexToRgba(hex) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var _hex$match$slice$map = hex.match(/#?(\w\w?)(\w\w?)(\w\w?)$/).slice(1, 4).map(function (h) {
    return parseInt(h, 16);
  }),
      _hex$match$slice$map2 = (0, _slicedToArray2["default"])(_hex$match$slice$map, 3),
      r = _hex$match$slice$map2[0],
      g = _hex$match$slice$map2[1],
      b = _hex$match$slice$map2[2];

  return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha, ")");
};

exports.hexToRgba = hexToRgba;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJoZXhUb1JnYmEiLCJoZXgiLCJhbHBoYSIsIm1hdGNoIiwic2xpY2UiLCJtYXAiLCJoIiwicGFyc2VJbnQiLCJyIiwiZyIsImIiXSwic291cmNlcyI6WyIuLi8uLi9zcmMvbGliL2NvbG9ycy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgaGV4VG9SZ2JhID0gKGhleDogc3RyaW5nLCBhbHBoYTogbnVtYmVyID0gMSkgPT4ge1xuICBjb25zdCBbciwgZywgYl0gPSBoZXhcbiAgICAubWF0Y2goLyM/KFxcd1xcdz8pKFxcd1xcdz8pKFxcd1xcdz8pJC8pXG4gICAgLnNsaWNlKDEsIDQpXG4gICAgLm1hcCgoaCkgPT4gcGFyc2VJbnQoaCwgMTYpKTtcbiAgcmV0dXJuIGByZ2JhKCR7cn0sJHtnfSwke2J9LCR7YWxwaGF9KWA7XG59O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUFPLElBQU1BLFNBQVMsR0FBRyxTQUFaQSxTQUFZLENBQUNDLEdBQUQsRUFBb0M7RUFBQSxJQUF0QkMsS0FBc0IsdUVBQU4sQ0FBTTs7RUFDM0QsMkJBQWtCRCxHQUFHLENBQ2xCRSxLQURlLENBQ1QsMEJBRFMsRUFFZkMsS0FGZSxDQUVULENBRlMsRUFFTixDQUZNLEVBR2ZDLEdBSGUsQ0FHWCxVQUFDQyxDQUFEO0lBQUEsT0FBT0MsUUFBUSxDQUFDRCxDQUFELEVBQUksRUFBSixDQUFmO0VBQUEsQ0FIVyxDQUFsQjtFQUFBO0VBQUEsSUFBT0UsQ0FBUDtFQUFBLElBQVVDLENBQVY7RUFBQSxJQUFhQyxDQUFiOztFQUlBLHNCQUFlRixDQUFmLGNBQW9CQyxDQUFwQixjQUF5QkMsQ0FBekIsY0FBOEJSLEtBQTlCO0FBQ0QsQ0FOTSJ9